import { useState, useEffect } from "react";
import styles from "./PaymentPopup.module.css";

export default function PaymentPopup({ display, hidePopupDisplay }) {
  return (
    <div
      className={styles.PaymentPopup}
      style={{ display }}
    >
      <div
        className={styles.PopupTransparentBg}
        id="PopupTransparentBg"
        onClick={() => hidePopupDisplay("none")}
      ></div>
      <div className={styles.PaymentPopupContent}>
        <button onClick={() => hidePopupDisplay("none")}>Back</button>
        <h2>OUR PRICING</h2>
        <div className={styles.PaymentCategory}>
          <h2>Ski Free</h2>
          <h2>($0/month)</h2>
          <p>Generate & Download 2 Design monthly</p>
          <p>Access only 1 Social Media Post Content Recommendation monthly</p>
        </div>
        <div>
          <div className={styles.PaymentCategory}>
            <h2>Ski Basic</h2>
            <h2>($9.99/month)</h2>
            <p>Generate & Download 6 Design monthly</p>
            <p>
              Access 3 unique Social Media post content Recommendations monthly
            </p>
            <p>Custom Design Download (PDF, JPG,PNG)</p>
            <div>
              <a
                href="https://flutterwave.com/pay/ski-basic-design"
                target="blank"
              >
                Upgrade
              </a>
            </div>
          </div>
          <div className={styles.PaymentCategory}>
            <img src="/SVG/Star.svg" alt="Star Icon" />
            <h2>Ski Pro</h2>
            <h2>($30/month)</h2>
            <p>Generate & Download 20 Design monthly</p>
            <p>
              Access 6 unique Social Media post content Recommendations monthly
            </p>
            <p>Custom Design Download (PDF, JPG,PNG)</p>
            <div>
              <a
                href="https://flutterwave.com/pay/ski-pro-design"
                target="blank"
              >
                Upgrade
              </a>
            </div>
          </div>
          <div className={styles.PaymentCategory}>
            <h2>Ski Enterprise</h2>
            <h2>(Request Quote)</h2>
            <p>Custom Design Download monthly</p>
            <p>Custom Daily Social Media post content (On your Email)</p>
            <p>Custom Design Download (PDF, JPG,PNG)</p>
            <div>
              <a href="mailto:contact.skidesign@gmail.com">Contact Us</a>
            </div>
            <p>contact.skidesign@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
